import { __decorate } from "tslib";
import { Pipe } from "@angular/core";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { OrganisationHeadingEnum } from "../../organisations/shared/models/organisation-heading-enum";
import { OrganisationLinkMap } from "../../organisations/shared/models/organisation-link-map.model";
import { OrganisationRoutingConstants } from "../../organisations/organisation-settings-routing.constants";
let AdminLinksWithOrganisationPipe = class AdminLinksWithOrganisationPipe {
    transform(organisationID) {
        const links = new Array();
        Object.keys(OrganisationHeadingEnum).forEach((organisationHeading) => {
            links.push({
                // @ts-ignore
                text: OrganisationHeadingEnum[organisationHeading],
                address: AppRoutingConstants
                    .createRouteToViewWithPrefixRouteSeparator(organisationID, OrganisationRoutingConstants.ORGANISATION_SETTINGS_ROUTE, 
                // @ts-ignore
                OrganisationLinkMap.get(OrganisationHeadingEnum[organisationHeading]))
            });
        });
        links.sort((a, b) => 0 - (a.text.toLowerCase() > b.text.toLowerCase().trim() ? -1 : 1));
        return links;
    }
};
AdminLinksWithOrganisationPipe = __decorate([
    Pipe({
        standalone: false,
        name: "adminLinksWithOrganisation"
    })
], AdminLinksWithOrganisationPipe);
export { AdminLinksWithOrganisationPipe };
